{
  "contactModal": {
    "delete": {
      "cancel": "Cancel",
      "confirm": "Delete",
      "error": {
        "contactWithInformationRequests": "Impossible to delete contact with assigned information requests",
        "default": "Error deleting contact",
        "title": "Error deleting contact"
      },
      "message": "Are you sure you want to delete the selected business partner? This action is irrevocable",
      "success": "Contact deleted successfully",
      "title": "Confirmation"
    }
  },
  "contacts": {
    "buttons": {
      "add": "New"
    },
    "table": {
      "headers": {
        "actions": "Actions",
        "email": "Contact Email",
        "id": "ID",
        "name": "Site name"
      }
    }
  },
  "onboarding": {
    "actions": {
      "activateAccount": "Activate account",
      "back": "← Back",
      "next": "Next"
    },
    "ariaLabel": "Onboarding steps",
    "gate": {
      "retryBanner": {
        "message": "An error occurred. Please refresh and try again.",
        "retry": "Retry"
      }
    },
    "placeholder": "Step content coming soon.",
    "stepIndicator": "Step {{current}} of {{total}}",
    "steps": {
      "my_facilities": {
        "name": "Facilities",
        "subtitle": "Tell us which production facilities you are working with and their parent company.",
        "title": "Add your production facilities"
      },
      "register_bp": {
        "name": "Business partners",
        "subtitle": "List the key contacts at partner organisations — buyers, agents, or subcontractors we should reach for traceability requests.",
        "title": "Add your business partners"
      },
      "review": {
        "name": "Review",
        "subtitle": "Check everything looks right before we activate your account.",
        "title": "Review your details"
      },
      "verify_company": {
        "name": "Verify company",
        "subtitle": "Confirm we have the right business on file before you continue.",
        "title": "Verify your company profile"
      },
      "welcome": {
        "name": "Welcome",
        "subtitle": "",
        "title": "Welcome to Trace for Good"
      }
    },
    "verifyCompany": {
      "outcomes": {
        "answer_on_behalf": {
          "description": "For consultants, agents or partners filling in for the company shown above. Next, you'll register your company — responses stay attributed to you as their agent.",
          "label": "This is not my company, but I'm responding on their behalf"
        },
        "claim_company": {
          "description": "Confirm the profile above and continue setup as an employee of this company.",
          "label": "Yes, this is my company — I'd like to validate it"
        },
        "not_related": {
          "description": "Stops this verification. The person who invited you to Trace For Good will be notified so they can rectify the company shown above.",
          "label": "This isn't my company"
        }
      },
      "prompt": "Is this the profile of the company you are working at?",
      "summary": {
        "city": "City",
        "country": "Country",
        "street": "Street"
      }
    },
    "welcome": {
      "checkInfo": "Before accessing your Trace for Good account, we would like to check some information with you.",
      "intro": "We're glad to have you on board. This portal has been designed to facilitate collaboration between business partners from multiple supply chains in the context of product traceability and compliance.",
      "invitation": "You have been invited on the Trace for Good platform by <strong>{{invitingCompanyName}}</strong> to participate in a product traceability process. This process might require you to provide information regarding product supply chains."
    }
  },
  "productionSiteModal": {
    "actions": {
      "addRegistrationId": "Add registration ID",
      "backToProductionSite": "Back to facility form",
      "cancel": "Cancel",
      "delete": "Delete",
      "removeRegistrationId": "Remove registration ID",
      "save": "Save"
    },
    "createTitle": "Create facility",
    "delete": {
      "cancel": "No",
      "confirm": "Yes",
      "message": "Are you sure you want to delete this production site?",
      "title": "Facility deleted"
    },
    "editTitle": "Edit facility",
    "errors": {
      "cityRequired": "City is required",
      "coordinatesMaxDecimals": "Latitude and longitude can have at most 6 decimal places",
      "countryMustBeValid": "Country must be valid",
      "internalCodeTooLong": "The internal code must be less than 32 characters",
      "nameRequired": "Name is required",
      "parentCompanyRequired": "Parent Company is required",
      "postalCodeTooShort": "Postal code must be at least 3 characters",
      "streetRequired": "Street is required",
      "streetTooShort": "Street must be at least 3 characters"
    },
    "labels": {
      "city": "City",
      "country": "Country",
      "internalCode": "Other internal code",
      "latitude": "Latitude",
      "longitude": "Longitude",
      "name": "Facility name",
      "parentCompany": "Parent Company",
      "performedActivities": "Performed activities",
      "postalCode": "Postal code",
      "registrationId": "Facility registration IDs",
      "street": "Street"
    },
    "parentCompanyChange": {
      "cancel": "Cancel",
      "confirm": "Confirm",
      "message": "The Parent Company is the company this site belongs to. Changing it will update ownership for this facility and may affect traceability routing.",
      "title": "Change parent company?"
    },
    "placeholders": {
      "city": "e.g. Dhaka",
      "country": "Select country where the facility is located",
      "internalCode": "e.g. BD-DAK-001 or your internal reference",
      "latitude": "e.g. 48.8566",
      "longitude": "e.g. 2.3522",
      "name": "e.g. Dhaka Cut & Sew Unit A",
      "parentCompany": "e.g. Trace for Good",
      "performedActivities": "e.g. Cutting, sewing, finishing, dyeing",
      "postalCode": "e.g. 1207",
      "registrationId": "e.g. VAT number, CIN, GSTIN, USC",
      "street": "e.g. 221B Baker Street"
    },
    "registrationIdDescriptions": {
      "DUNS": "DUNS: 9-digit number.",
      "EORI": "EORI: country code + 14-digit number.",
      "GLN": "GLN: 13-digit number.",
      "OTHER": "Other: max 32 characters.",
      "RCS": "RCS: RCS + space + company name + space + [A,B] + space + 9-digit number.",
      "VAT": "VAT: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
    },
    "registrationIdErrors": {
      "DUNS": "DUNS registration ID must be in format: 9-digit number.",
      "EORI": "EORI registration ID must be in format: country code (e.g., FR) + 14-digit number.",
      "GLN": "GLN registration ID must be in format: 13-digit number.",
      "OTHER": "Other registration ID must be less than 32 characters.",
      "RCS": "RCS registration ID must be in format: RCS + space + company name + space + [A,B] + space + 9-digit number.",
      "VAT": "VAT registration ID must be in format: country code (e.g., FR) + 2-digit key + 9-digit SIREN number."
    },
    "tabs": {
      "generalInfo": "Information",
      "location": "Location"
    },
    "tooltips": {
      "address": "Complete address of the facility. Used to identify and trace this location in your records.",
      "city": "City or town where the facility is located.",
      "country": "Country where the facility operates.",
      "internalCode": "Short internal code your team uses to recognize this facility.",
      "latitude": "Optional: latitude of the facility in decimal degrees (e.g. 48.8566).",
      "longitude": "Optional: longitude of the facility in decimal degrees (e.g. 2.3522).",
      "name": "Name you use internally to refer to this facility.",
      "parentCompany": "Parent Company that owns the facility, selected from the list of registered business partners.",
      "parentCompanyEdit": "Select the company that owns this site.",
      "parentCompanyReadOnly": "Only the organization that created or owns this facility can change the parent company.",
      "performedActivities": "What this facility does (e.g. processing, packaging, storage).",
      "postalCode": "Postal or ZIP code where the facility is located.",
      "registrationId": "Official site identification number (VAT Number, CIN, GSTIN, USC, etc.).",
      "street": "Street number and line for the facility address."
    }
  },
  "productionSites": {
    "buttons": {
      "add": "New"
    },
    "create": {
      "error": "Error creating facility",
      "successCreated": {
        "message": "The facility has been created successfully",
        "title": "Facility created"
      },
      "successMerged": {
        "message": "An existing facility was matched and linked successfully",
        "title": "Facility linked"
      }
    },
    "delete": {
      "error": "Error deleting facility",
      "success": {
        "message": "The facility has been deleted successfully",
        "title": "Facility deleted"
      }
    },
    "filters": {
      "country": "Country",
      "internalCode": "Other internal code",
      "isConfidential": "Confidential",
      "isConfidentialFalse": "No",
      "isConfidentialTrue": "Yes",
      "name": "Facility name",
      "nothingFoundMessage": "No results found",
      "performedActivities": "Performed activities",
      "searchPlaceholder": "Search filters",
      "title": "Filters"
    },
    "search": {
      "placeholder": "Search by name or address"
    },
    "sorts": {
      "address": "Location",
      "country": "Country",
      "email": "Email",
      "internalCode": "Other internal code",
      "name": "Name"
    },
    "table": {
      "headers": {
        "address": "Location",
        "certificates": "Certificates",
        "deleted": "Deleted",
        "id": "ID",
        "internalCode": "Other internal code",
        "name": "Facility name",
        "parentCompany": "Parent Company",
        "performedActivities": "Performed activities",
        "registrationId": "Facility registration IDs"
      }
    },
    "title": "Facilities",
    "update": {
      "error": "Error updating facility",
      "partialSave": {
        "message": "The facility has been updated partially"
      },
      "success": {
        "message": "The facility has been updated successfully",
        "title": "Facility updated"
      }
    }
  },
  "request": {
    "errors": {
      "generic": "Error"
    }
  }
}
